import { ChecklistItem, Goal } from 'Generated/graphql-types'

export type DashboardFilters = {
  categories: string[]
  taskOwnerId: string
  goalTitleValues: string[]
}

export type FilterArgs = {
  value: string | string[] | boolean
  filterType: keyof DashboardFilters
}

// eslint-disable-next-line no-shadow
export enum TabFilterKeyEnum {
  all = 'all',
  assignedToMe = 'assignedToMe',
  completed = 'completed',
  pastDue = 'pastDue',
  todo = 'todo',
  unassigned = 'unassigned',
}

export type Tab = {
  count: number
  filterKey: TabFilterKeyEnum
  label: string
}

export type CheckListItemWithGoalInfo = Omit<
  ChecklistItem,
  'lastUpdatedUser'
> & {
  goal: Goal
}

export type ResourceIdToTaskIdMap = Record<string, number>
